import { Grid } from "@mui/material";
import { MprcButton } from "components";
import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { FavoriteButton, LikeButton, ShareButton } from "views/knowledge/components/card/behaviors/common/Interaction";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { DefaultOptions } from "./DefaultOptions";
import { ModerateThreadFooter } from "./ModerateThreadFooter";

export const ThreadMasterButton = () => {
    const { pub } = useCardContext();
    var navigate = useNavigate();
    const { t } = useTranslation("knowledge");

    return (
        <MprcButton
            color="primary"
            variant="contained"
            onClick={() => navigate(KnowledgePaths.PostViewer(pub.masterPublication!.publicationId))}
            disabled={pub.masterPublication?.isAvailable === false}
        >
            {t("Feed.Card.Common.TheadSeeAllButtonText")}
        </MprcButton>
    );
};

///
export const ThreadItemFooter = () => {

    const { pub } = useCardContext();

    if (pub.approvalStatus != PublicationApprovalStatus.Approved)
        return <ModerateThreadFooter />;

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        <ThreadMasterButton />
                    </Grid>
                    <Grid>
                        <LikeButton />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid>
                        <FavoriteButton />
                    </Grid>
                    <Grid>
                        <ShareButton />
                    </Grid>
                    <Grid>
                        <DefaultOptions />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
